import { Reveal } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, intro, image }) {
  return (
    <section className="relative pt-32 md:pt-44 pb-16 md:pb-24 overflow-hidden">
      {image && (
        <div className="absolute inset-0 z-0">
          <img
            src={image}
            alt=""
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-ink-base/80 via-ink-base/90 to-ink-base" />
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <Reveal>
          {eyebrow && <p className="label-eyebrow mb-4">{eyebrow}</p>}
          <h1 className="font-heading font-bold tracking-tighter leading-none text-5xl md:text-6xl lg:text-7xl text-white max-w-4xl text-balance">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-lg md:text-xl text-zinc-400 max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
